import { z } from "zod";

import dayjs from "dayjs";

// ReportPlanoAuditoriaSchema
 

export const ReportPlanoAuditoriaSchema = z.object({
  IdAuditoria: z.coerce.number(),
});

// ReportPlanoAuditoriaForm
 

export type ReportPlanoAuditoriaForm = z.infer<typeof ReportPlanoAuditoriaSchema>;

// defaultReportPlanoAuditoriaValues


export const defaultReportPlanoAuditoriaValues: Partial<ReportPlanoAuditoriaForm> = {}